<template>
    <div>
        <div class="banner_box" v-if="bannerList.length">
            <swiper ref="myBanner" :options="bannerOptions">
                <swiper-slide v-for="item in bannerList" :key="item.id"
                              :style="{background: 'url('+ api + item.background +') 100% 100% / cover no-repeat'}">
                    <b-container @click="bannerClick(item)">
                        <b-row class="banner_row">
                            <b-col sm="12" md="6">
                                <img :src="api+item.leftBackground" class="banner_img_left">
                            </b-col>
                            <b-col sm="12" md="6">
                                <img :src="api+item.rightBackground" class="banner_img_right">
                            </b-col>
                        </b-row>
                    </b-container>
                </swiper-slide>
                <div class="swiper-pagination"></div>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </swiper>

        </div>

        <div class="home_product">
            <b-container>
                <div class="clearfix">
                    <div class="product_left leftIn" ref="productLeft"
                         style="width:calc(100% - 510px);min-width:375px;float: left">
                        <div class="item" v-for="item in productList" :key="item.id"
                             :class="{'active':curProduct.id===item.id}"
                             @mouseenter="switchProduct(item)" @click="curProduct = item">
                                    <span class="img_box">
                                      <img :src="api+item.background">
                                    </span>
                            <p class="name clamp1">{{ item.name }}</p>
                            <p class="dec">{{ item.title }}</p>
                        </div>
                    </div>
                    <div class="product_right rightIn" v-if="curProduct"
                         style="float: right;width: 510px;min-width: 375px"
                         @click="goProDetail(curProduct)">
                        <img src="../assets/product_bg.png" class="product_bg">
                        <transition name="fade">
                            <div class="product_img" v-if="curProduct.recommendImg">
                                <img :src="api+curProduct.recommendImg">
                            </div>
                        </transition>
                        <div class="bottom fault_btn" :data-text="curProduct.name">
                            <p class="name clamp1 left">{{ curProduct.name }}</p>
                            <div class="more right">
                                MORE
                                <img src="../assets/arrow_home.png">
                            </div>
                            <img src="../assets/new_more1.png">
                        </div>
                    </div>

                </div>
            </b-container>
        </div>

        <div class="consult" ref="consult" v-if="tabList[1]">
            <b-container>
                <div class="top_title" @click="goVideoAndNews(2)">
                    <span class="title1">{{ tabList[1].text }}</span>
                    <span class="title2">MORE</span>
                </div>

                <b-row>
                    <b-col md="6" v-for="item in videoList" :key="item.id" style="padding: 0 20px"
                           @click="goVideo(item)">
                        <div class="video_box">
                            <div class="img_box">
                                <img :src="api + item.thumbnailFile">
                                <img src="../assets/play-circle.png" alt="" class="play_img">
                            </div>

                            <div class="info clearfix" style="margin-top: 5px">
                                <p class="left video_title clamp1">{{ item.name }}</p>
                                <div class="right">
                                    <span class="text">MORE</span>
                                </div>
                            </div>
                            <p class="time">{{ item.updateTime || item.createTime }}</p>
                        </div>
                    </b-col>

                </b-row>

            </b-container>
        </div>
        <div class="consult" ref="consult" style="background-color: #121214" v-if="tabList[0]">
            <b-container>
                <div class="top_title" @click="goVideoAndNews(1)" style="margin-bottom: 24px">
                    <span class="title1">{{ tabList[0].text }}</span>
                    <span class="title2">MORE</span>
                </div>


                <div style="margin-bottom: 40px">
                    <i class="icon_left" @click="slideLeft()"></i>
                    <i class="icon_right" @click="slideRight()"></i>
                </div>

                <div class="clearfix"></div>
            </b-container>

            <swiper ref="mySwiper" :options="swiperOptions" class="consult_swiper">
                <swiper-slide v-for="item in informationList" :key="item.id" style="width: 375px;max-width: 375px;">
                    <div class="video_box" @click="$router.push('/news/about/detail?id='+item.id)">
                        <div class="img_box" style="height: auto">
                            <img :src="api + item.thumbnailFile">
                        </div>

                        <div class="info clearfix">

                            <div class="label" v-if="item.label">{{ item.label }}</div>

                            <div class="right">
                                <span class="text">MORE</span>
                            </div>
                        </div>

                        <p class="video_title clamp1">{{ item.name }}</p>

                        <p class="time">{{ item.updateTime || item.createTime }}</p>
                    </div>
                </swiper-slide>
            </swiper>

        </div>

        <div class="video_alert" v-if="videoAlert">
            <div class="content" id="content">
                <img src="../assets/close.png" class="close" @click="videoAlert = false">
                <iframe v-if="video.videoType == 2" :src="video.videoUrl"></iframe>

                <video controls v-if="video.videoType == 1">
                    <!--          https://cyberpunk-ec.gog-statics.com/video/Loop_LaunchTrailer.mp4-->
                    <source :src="video.videoUrl" type="video/mp4">
                    您的浏览器不支持 HTML5 video 标签。
                </video>
            </div>
        </div>


        <div class="home_remind" v-if="homeRemindAlert">
            <div class="content" v-if="languageNum == 3">
                <b-row>
                    <b-col md="9" sm="12">
                        <p class="text">
                            我们出于各种目的在此网站上使用 Cookie，包括改进网站性能、为您提供个性化体验。继续使用此网站，即表示您同意我们的
                            <span @click="goRemindPage('/clause')">使用条款</span>、<span
                                @click="goRemindPage('/cookiespolicy')">Cookies政策</span>及<span
                                @click="goRemindPage('/privacy')">隐私权保护政策</span>。
                        </p>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-button variant="danger" @click="homeRemindClick(false)">拒绝</b-button>
                        <b-button class="success_btn" variant="success" @click="homeRemindClick(true)">接受</b-button>
                    </b-col>
                </b-row>
            </div>

            <div class="content" v-else>
                <b-row>
                    <b-col md="9" sm="12">
                        <p class="text">
                            We use cookies on this site for carious purposes, including to enhance site performance,
                            personalize your experience. By continuing to use this site, you are agreeing to our
                            <span @click="goRemindPage('/clause')">terms of use</span>、<span
                                @click="goRemindPage('/cookiespolicy')">Cookies policy</span>and <span
                                @click="goRemindPage('/privacy')">privacy policy</span>.
                        </p>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-button variant="danger" @click="homeRemindClick(false)">refuse</b-button>
                        <b-button class="success_btn" variant="success" @click="homeRemindClick(true)">accept</b-button>
                    </b-col>
                </b-row>
            </div>

        </div>

    </div>
</template>

<script>

    import {getBanner, getGoods, getInformation} from '../api/HomeService'
    import {api} from '../api/api';

    let width = document.body.clientWidth

    export default {
        name: "Home",
        data() {
            return {
                homeRemindAlert: false,
                bannerOptions: {
                    speed: 500,
                    loop: true,
                    effect: 'fade',
                    autoplay: {
                        delay: 400000
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                },

                swiperOptions: {
                    freeMode: width < 1200,
                    slidesPerView: Math.floor(width / 375),
                    // slidesOffsetBefore: -405,
                    slidesOffsetBefore: width < 1200 ? 0 : -405,
                    spaceBetween: 20,
                    centeredSlides: true,
                    navigation: {
                        nextEl: '.button-next',
                        prevEl: '.button-prev',
                    }

                    // slidesPerView: Math.floor(width / 375),
                    // slidesOffsetBefore: width < 740 ? 0 : -605,
                    // // slidesOffsetBefore: 0,
                    // spaceBetween: 20,
                    // centeredSlides: true,
                    // centeredSlidesBounds: true,
                },
                videoAlert: false,
                video: {},
                tabList: [],
                curTab: 1,
                languageNum: window.localStorage.getItem("languageNum"),
                bannerList: [],
                bannerBackground: '',
                productList: [],
                curProduct: {},
                informationList: [],
                videoList: [],
                informationShow: 0,
                api: api,
                mySwiper: {},
                slideIndex: 0
            }
        },
        methods: {

            goRemindPage(url) {
                let lang;
                if (this.languageNum == 1) {
                    lang = '/en';
                } else if (this.languageNum == 2) {
                    lang = '/en-us';
                } else if (this.languageNum == 3) {
                    lang = '/zh-hans';
                } else if (this.languageNum == 4) {
                    lang = '/zh-hant';
                } else if (this.languageNum == 5) {
                    lang = '/de';
                } else if (this.languageNum == 6) {
                    lang = '/fr';
                } else if (this.languageNum == 7) {
                    lang = '/it';
                } else if (this.languageNum == 7) {
                    lang = '/es';
                }

                this.$router.push(lang + url)
            },

            homeRemindClick(status) {
                this.homeRemindAlert = false;
                if (status) {
                    window.sessionStorage.setItem("homeRemindAlert", '1');
                }
            },

            goProDetail(item) {
                document.title = item.name;
                this.$router.push('/product/detail?id=' + item.id)
            },

            slideRight() {
                if (this.slideIndex < (this.informationList.length - 2)) {
                    this.slideIndex = this.slideIndex + 1;
                    this.$refs.mySwiper.$swiper.slideTo(this.slideIndex, 300, false)
                } else {
                    this.slideIndex = this.informationList.length - 1;
                    this.$refs.mySwiper.$swiper.slideTo(this.slideIndex, 300, false)
                }

            },

            slideLeft() {
                if (this.slideIndex > 0) {
                    this.slideIndex = this.slideIndex - 1;
                    this.$refs.mySwiper.$swiper.slideTo(this.slideIndex, 300, false)
                } else {
                    this.slideIndex = 0;
                    this.$refs.mySwiper.$swiper.slideTo(this.slideIndex, 300, false)
                }
            },

            goVideo(item) {
                this.videoAlert = true
                this.video = item;
                setTimeout(() => {
                    document.getElementById("content").style.height = document.getElementById("content").offsetWidth * .56 + 'px'
                })
            },

            goVideoAndNews(type) {
                let lang;
                if (this.languageNum == 1) {
                    lang = '/en';
                } else if (this.languageNum == 2) {
                    lang = '/en-us';
                } else if (this.languageNum == 3) {
                    lang = '/zh-hans';
                } else if (this.languageNum == 4) {
                    lang = '/zh-hant';
                } else if (this.languageNum == 5) {
                    lang = '/de';
                } else if (this.languageNum == 6) {
                    lang = '/fr';
                } else if (this.languageNum == 7) {
                    lang = '/it';
                } else if (this.languageNum == 7) {
                    lang = '/es';
                }

                if (type == 1) {
                    this.$router.push(lang + '/about/news')
                } else if (type === 2) {
                    this.$router.push(lang + '/about/video')
                }
            },

            bannerClick(item) {
                if (item.url) {
                    window.open(item.url)
                }
            },

            switchTab(id) {
                this.curTab = id;
                this.getInformationList()
            },

            onSlideStart(slide) {
                this.bannerBackground = this.bannerList[slide].background;
            },

            switchProduct(item) {
                this.curProduct = {};
                setTimeout(() => {
                    this.curProduct = item
                }, 200)
            },


            getBannerList() {
                getBanner(this.languageNum, data => {
                    this.bannerList = data;
                    this.bannerBackground = data[0].background;
                })
            },

            getGoodsList() {
                let sendData = {
                    languageNum: this.languageNum,
                    isRecommend: 1,
                    pageNum: 1,
                    pageSize: 4,
                }
                getGoods(sendData, data => {
                    this.productList = data.rows;
                    this.curProduct = this.productList[0]
                })
            },

            getInformationList(type) {
                let sendData = {
                    pageSize: type == 1 ? 8 : 2,
                    pageNum: 1,
                    isAsc: "asc",
                    languageNum: this.languageNum,
                    type: type
                }

                getInformation(sendData, data => {
                    if (type == 1) {
                        this.informationList = data
                    } else {
                        this.videoList = data
                    }
                })
            },

            // handleScroll() {
            //   if (this.$refs.consult && this.$refs.consult.getBoundingClientRect().top < 700) {
            //     if (interval === null) {
            //       interval = setInterval(() => {
            //         this.informationShow++;
            //         if (this.informationShow >= (this.informationList.length + 1)) {
            //           window.clearInterval(interval)
            //           interval = null;
            //         }
            //       }, 200)
            //     }
            //   } else {
            //     this.informationShow = 0
            //     window.clearInterval(interval)
            //     interval = null;
            //   }
            // },

            init() {
                this.getBannerList();
                this.getGoodsList();
                this.getInformationList()
            }
        },


        mounted() {

            let homeRemindAlert = window.sessionStorage.getItem("homeRemindAlert");

            this.homeRemindAlert = !homeRemindAlert;


            let menuList = JSON.parse(window.localStorage.getItem('menuList'));
            for (let i = 0; i < menuList.length; i++) {
                if (menuList[i].children) {
                    for (let j = 0; j < menuList[i].children.length; j++) {
                        if (menuList[i].children[j].menuUrl.indexOf('/video') > 0) {
                            let temp = {id: 2, text: ""};
                            temp.text = menuList[i].children[j].title
                            this.tabList.push(temp)
                            this.getInformationList(2)
                        }

                        if (menuList[i].children[j].menuUrl.indexOf('/news') > 0) {
                            let temp = {id: 1, text: ""};
                            temp.text = menuList[i].children[j].title
                            this.tabList.push(temp)
                            this.getInformationList(1)
                        }
                    }
                }
            }
        },

        created() {
            this.init()
        }

    }
</script>

<style scoped lang="scss" src="../css/home.scss">
</style>
